import React from "react";
// JavaScript library for creating fancy carousels like components
import Glide from "@glidejs/glide";
// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

import { Link } from "react-router-dom";

// Core Components
import AmandaImg from "assets/img/amanda.jpeg";
import MaddyImg from "assets/img/maddy.jpeg";
import IreneImg from "assets/img/irene.jpeg";
import JoshImg from "assets/img/test2.jpeg";

import TestimonialCard from "../../components/cards/TestimonialCard";


import Carousel from "../../components/carousel/Carousel";
/* import RedHex from "../../../../assets/images/svg/LandingRedPoly.svg";
import YelloHex from "../../../../assets/images/svg/LandingYellowPoly.svg";
import BlueHex from "../../../../assets/images/svg/LandingBluePoly.svg"; */

export default function MobileTestimonials() {
  const maddyTestimonial =
    "This platform is awesome! The most amazing part is that no installation of any sort is required. HD video quality, clear audio, and easy screen-sharing. Also consumes much less data than any other product. We've tried this on several browsers and it just works everytime.";
  const amandaTestimonial =
    "My experience with SecureMeeting has been wonderful. Not only is it very simple to use, but it also has complete functionality for all my needs. Not to mention, it's lack of bulky toolbars and login/accounts make it very aesthetically pleasing. Beautiful product!";

  const joshTestimonial =
    "This is so insanely simple to use! Love this initiative. You guys are amazing. Your dedication to open source is inspirational. Thank you SecureMeeting for caring! Video quality is crisp, and I love that I can use it on Linux. I use a lot of screensharing for coding and gaming. ";

  const ireneTestimonial =
    "I really like SecureMeeting. I enjoy how prominent the video is, with no lagging, allows you to focus on person you are talking to without distractions, very simple and clean design overall. Great audio quality too! Removes headache of installing apps and setting things up. Great job! ";

  const testimonials = [
    <TestimonialCard
      picture={MaddyImg}
      name="Maddy"
      testimonial={maddyTestimonial}
    />,
    <TestimonialCard
      picture={AmandaImg}
      name="Amanda"
      testimonial={amandaTestimonial}
    />,
    <TestimonialCard
      picture={JoshImg}
      name="Josh"
      testimonial={joshTestimonial}
    />,
    <TestimonialCard
      picture={IreneImg}
      name="Irene"
      testimonial={ireneTestimonial}
    />,
  ];
  return (
    <section>
      <div className="d-flex justify-content-center flex-column">
        <h1 className="display-3 text-center w-100 px-3">
          Loved by everyone.
        </h1>
        <h2 className="lead mt-0 w-100 text-center font-weight-normal px-3">
          SecureMeeting has been used in over 60 countries worldwide, hear what
          some of our users have to say.
        </h2>
      </div>
      <div className="testimonial-container">
        <Carousel slides={testimonials} />
      </div>
    </section>
  );
}